import template from './site-view.html';
import ListViews from '../models/views.models';

class SiteViewController {
  constructor($state, sitesService, filtersService, $scope, $stateParams, $location) {
    'ngInject';

    this.sitesService = sitesService;
    this.filtersService = filtersService;
    this.$state = $state;
    this.$scope = $scope;
    this.$stateParams = $stateParams;
    this.$location = $location;

    this.seenIn = this.sitesService.seenIn;
    this.usedIn = this.sitesService.usedIn;

    this.loading = false;
    this.assets = [];
    this.viewName = '';
    this.views = ListViews;

    this.query = '';
    this.filters = [];
    this.getFilterByName = null;
    this.ViewPreDefineFilter = undefined;
    this.onItemClick = this.onItemClick.bind(this);
  }

  $onInit() {
    this.getSiteView();
    this.connection = this.sitesService.registerView(this);
    this.setView(this.$location.search().v);
  }

  $onDestroy() {
    this.sitesService.unRegisterView(this.connection);
  }

  setView(viewName) {
    viewName = viewName in ListViews ? viewName : 'overview';
    if (this.viewName === viewName) return;

    this.viewName = viewName;
    const view = ListViews[this.viewName] || {};
    this.columnsDef = (view.columnsDef || []).map((col) => {
      if (col.field === 'name') {
        col.ascending = true;
      } else {
        col.ascending = undefined;
      }
      return col;
    });
    this.hideOnSiteChart = view.excludeChart === 'onsite';
    this.hideUsageChart = view.excludeChart === 'usage';
    this.$location.search({ v: this.viewName });
    this.getFiltersByKeys(view.filters);
    this.ViewPreDefineFilter = view.preDefineFilter;
    this.sitesService.updateViews();
  }

  updateBindings() {
    this.total = this.sitesService.totalInventory;
    this.onSitePercent = this.sitesService.onSitePercent;
    this.usedInPercent = this.sitesService.usedInPercent;
    this.filtersView = this.getAppliedFiltersView();
    this.usageStatus = this.sitesService.usageStatus;
    const usageDataLoaded = this.sitesService.usageStatus === 'loaded';
    const siteDataLoaded = this.sitesService.siteStatus === 'loaded';
    this.sitesService
      .getAssetsByFilter(this.query, this.filters, this.ViewPreDefineFilter)
      .then((assets) => {
        this.assets = assets;
        if (siteDataLoaded) {
          this.loading = false;
        }
        if (this.assets) {
          this.sitesService.getLastSeenChartData(this.assets).then((data) => {
            this.lastSeenChartData = data;
          });
          if (usageDataLoaded)
            this.sitesService.getUsageChartData(this.assets).then((data) => {
              this.usageChartData = data;
            });
        }
      })
      .catch((e) => {
        console.error(e);
        this.error = true;
        this.loading = false;
      });
  }

  getSiteView() {
    this.loading = true;
    this.sitesService
      .getSite(this.$stateParams.id)
      .then((s) => {
        this.site = s || {};
        this.getAssets(s.assets);
      })
      .catch((e) => {
        console.error(e);
        this.error = true;
        this.loading = false;
      })
      .finally(() => {
        this.updateBreadcrumb();
      });
  }

  updateBreadcrumb() {
    this.$scope.siteName = (this.site || {}).name || '';
    this.$scope.$emit('$viewContentLoaded');
  }

  getAssets(assetIds) {
    this.sitesService
      .getSiteAssetsByIds(assetIds)
      .then(() => {})
      .catch((e) => {
        this.loading = false;
        this.error = true;
        console.log(e);
      });
  }

  onSliceClick(key, prop) {
    // set the filter or clear it if its been set before
    const filter = this.getFilterByName(prop);

    if (filter) {
      if (filter.value !== key) {
        filter.value = key;
      } else {
        filter.value = '';
      }

      this.updateBindings();
    }
  }

  getAppliedFiltersView() {
    return this.filters.filter((filter) => {
      return !!(filter.value || '');
    });
  }

  onFiltersChanged() {
    this.sitesService.updateViews();
  }

  getFiltersByKeys(filtersKeys = []) {
    [this.filters, this.getFilterByName] = this.filtersService.getDefaultFilters(filtersKeys);
  }

  clearFilters() {
    this.filters.forEach((filter) => {
      filter.value = '';
    });

    this.onFiltersChanged();
  }

  toggleFilters() {
    this.showFilters = !this.showFilters;
  }

  hideFilters() {
    this.showFilters = false;
  }

  get filtersCount() {
    return this.filters.filter((item) => !!(item.value || '')).length;
  }

  getCsvData() {
    return this.sitesService.getCsvData(this.assets, this.columnsDef);
  }

  getCsvFileName() {
    return `${this.viewName}-${moment().format('YYYY-MM-DD:hh-mm-ss')}.csv`;
  }

  closeManageSite() {
    this.manage = false;
    this.getSiteView();
  }

  onItemClick(event, item, index) {
    if (item && item.name) {
      const filter = this.getFilterByName('name');
      if (filter) {
        filter.value = item.name;
        this.updateBindings();
      }
    }
  }
}

export default {
  template,
  controller: SiteViewController,
  controllerAs: 'siteVm',
  bindings: {},
};
